import React from 'react'
import './ClientLogo.scss'
export interface IClientReference {
  width: number
  height?: number
  filename: string
  title: string
  url: string
}

const ClientLogo = ({ filename, title, url, width }: IClientReference) => (
  <a className="clientLogo" href={url} target="_blank" rel="noreferrer">
    <img
      loading="lazy"
      src={`/client-logos/${filename}`}
      alt={`${title} logo`}
      width={width}
    />
  </a>
)

export default ClientLogo
